module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_8f3c9da4.f3381ca2.woff";